<p class="text">
  <slot />
</p>

<style>
  .text {
    font-size: 22px;
    line-height: 135.8%;
    padding: 0 10px;
    text-align: center;
    margin: 25px 0;
    color: #fff;
  }

  .text:first-of-type {
    margin-top: 5px;
  }
</style>
